/**
 * @generated SignedSource<<ec720dd266e5cb3eb0374cbdc82658ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_user$data = {
  readonly recentHistoryItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly browseUrl: string | null;
        readonly categoryCode: string | null;
        readonly categoryPath: string | null;
        readonly contemporaryTrackingString: string;
        readonly firstPhotoWebPath: string | null;
        readonly pdpURL: string | null;
        readonly seller: {
          readonly serviceId: string | null;
        } | null;
        readonly serviceId: string | null;
        readonly title: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespAboutModule_user" | "PdpRespAboutTabs_user" | "PdpRespBuyerAssuranceBox_user" | "PdpRespDealerDetails_user" | "PdpRespDetailsTabs_user" | "PdpRespHeroCarousel_user" | "PdpRespPersonalizedItemsCarousel_user" | "PdpRespSellerItemsCarousel_user" | "PdpRespSellerItems_user" | "PdpRespShippingReturns_user" | "PdpRespSidebarBlurbs_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarContact_user" | "PdpRespSidebarSellerInfoAndContactLazy_user" | "PdpRespSidebarSellerInfo_user" | "PdpRespSimilarAuctionItemsLazy_user" | "PdpRespSimilarItemsCarousel_user" | "PdpRespSimilarItemsFooter_user" | "PdpRespSimilarItemsLanding_user" | "PdpRespSwatchSelector_user" | "PdpRespTopModule_user" | "PdpRespYMALItemsCarousel_user" | "PdpSharedPromoCode_user">;
  readonly " $fragmentType": "PdpRespContainer_user";
};
export type PdpRespContainer_user$key = {
  readonly " $data"?: PdpRespContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_user">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUserRecentHistoryItem"
    },
    {
      "kind": "RootArgument",
      "name": "hasRestyledProductTiles"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPdpRedesignVariant"
    },
    {
      "kind": "RootArgument",
      "name": "localRecentHistoryItemIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_user",
  "selections": [
    {
      "condition": "hasRestyledProductTiles",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsFooter_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItems_user"
        }
      ]
    },
    {
      "condition": "hasRestyledProductTiles",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespYMALItemsCarousel_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPersonalizedItemsCarousel_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSimilarItemsCarousel_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItemsCarousel_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespBuyerAssuranceBox_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfo_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContactLazy_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_user"
    },
    {
      "condition": "isPdpRedesignVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespAboutTabs_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTopModule_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDetailsTabs_user"
    },
    {
      "condition": "fetchUserRecentHistoryItem",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "recentHistoryItems",
          "args": [
            {
              "kind": "Variable",
              "name": "excludeItemPks",
              "variableName": "localRecentHistoryItemIds"
            }
          ],
          "concreteType": "RecentHistoryItemsConnection",
          "kind": "LinkedField",
          "name": "__getRecentHistory_recentHistoryItems_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RecentHistoryItemsEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contemporaryTrackingString",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "size",
                          "value": "small"
                        }
                      ],
                      "kind": "ScalarField",
                      "name": "firstPhotoWebPath",
                      "storageKey": "firstPhotoWebPath(size:\"small\")"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "pdpURL",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "title",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "browseUrl",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "categoryCode",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "categoryPath",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Seller",
                      "kind": "LinkedField",
                      "name": "seller",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarAuctionItemsLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "9aa43139d76d175324f4131e31b8e277";

export default node;
